import React from "react";

import { VerificationEditingRequest } from "models";

import { Col, InsightCard } from "components";

export const EditingRequestInsightCards = ({
  loading,
  editingRequests,
  requestType,
}: {
  loading: boolean;
  editingRequests: VerificationEditingRequest[];
  requestType: VerificationEditingRequest["requestType"];
}) => {
  const filteredEditingRequests = editingRequests.filter((request) => request.requestType.includes(requestType));
  const openEditingRequests = filteredEditingRequests?.filter(({ completedAt }) => !completedAt);
  const completedEditingRequests = filteredEditingRequests?.filter(({ completedAt, reviewedAt }) => !!completedAt && !reviewedAt);
  const reviewedEditingRequests = filteredEditingRequests?.filter(({ reviewedAt }) => !!reviewedAt);

  return (
    <>
      <Col sm={12} md={4}>
        <InsightCard loading={loading} label="open editing requests">
          {openEditingRequests?.length}
        </InsightCard>
      </Col>

      <Col sm={12} md={4}>
        <InsightCard loading={loading} label="to review editing requests">
          {completedEditingRequests?.length}
        </InsightCard>
      </Col>

      <Col sm={12} md={4}>
        <InsightCard
          loading={loading}
          label="reviewed editing requests"
          status={filteredEditingRequests?.length > 0 && reviewedEditingRequests?.length === filteredEditingRequests?.length ? "success" : ""}
        >
          {reviewedEditingRequests?.length}
        </InsightCard>
      </Col>
    </>
  );
};
